import { createStore } from "vuex"

export default createStore({
    state: {
        page: {
            index: 1,
            path: [
                {
                    page: 1,
                    name: "step1",
                },
                {
                    page: 2,
                    name: "",
                },
                {
                    page: 3,
                    name: "step3",
                },
            ],
        },
        payment_info: {
            amount: -1,
            type_payment: null,
            city: null,
            payment_option: null,
            agree: false,
        },
        user_info: {
            type_customer: null,
            firstname: null,
            lastname: null,
            streetname: null,
            housenumber: {
                number: null,
                addition: "",
            },
            postalcode: null,
            city: null,
            email: null,
            birthday: {
                day: null,
                month: null,
                year: null,
            },
        },
    },
})
